<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Client" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Client Rate</h4>
                    </div>
                    <vs-button
                        color="primary"
                        class="btn mb-4 md:mb-0 mr-1"
                        @click="submitForm"
                    >Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input disabled class="w-full" label="ID *" v-model="data.id" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Client ID *</label>
                                <v-select
                                    :options="clientOption"
                                    v-model="data.client_id"
                                    label="client_code"
                                    :reduce="client_id => client_id.id"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Origin ID *</label>
                                <v-select
                                    :options="areaOptions"
                                    v-model="data.origin_id"
                                    label="village"
                                    :reduce="area_id => area_id.id"
                                    @search="searchArea"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Destination ID *</label>
                                <v-select
                                    :options="areaOptions"
                                    v-model="data.destination_id"
                                    label="village"
                                    :reduce="area_id => area_id.id"
                                    @search="searchArea"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Vehicle Type ID *</label>
                                <v-select
                                    :options="vehicleTypeOption"
                                    v-model="data.vehicle_type_id"
                                    label="vehicle_type"
                                    :reduce="vehicle_type_id => vehicle_type_id.id"
                                    @search="searchVehicleType"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Contract Type ID *</label>
                                <v-select
                                    :options="contractTypeOption"
                                    v-model="data.contract_type_id"
                                    label="contract_type"
                                    :reduce="contract_type_id => contract_type_id.id"
                                    @search="searchContractType"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Service Type ID</label>
                                <v-select
                                    :options="serviceTypeOption"
                                    v-model="data.service_type_id"
                                    label="service_type"
                                    :reduce="service_type_id => service_type_id.id"
                                    @search="searchVehicleType"
                                ></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <!-- <vs-input  class="w-full" label="Status" v-model="data.status.name" :disabled="true"/> -->
                                <label for class="vs-input--label">Status</label>
                                <vs-switch class="mt-2" v-model="data.is_active">
                                    <span slot="on">Active</span>
                                    <span slot="off">Deactive</span>
                                </vs-switch>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-6">
                    <vs-tab label="Trip Rate">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Currency *</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="currencyOption"
                                            v-model="data.currency_id"
                                            label="currency_code"
                                            :reduce="currency_id => currency_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Fixed Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.fixed_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Quota Trip</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.quota_trip" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Period</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="periodRateOption"
                                            v-model="data.period_id"
                                            label="name"
                                            :reduce="period_id => period_id.id"
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Excess Trip Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.excess_trip_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Trip Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.trip_rate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Variables">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/3 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Volume Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.volume_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">Min Volume</div>
                                    <div class="vx-col w-2/3">
                                        <!-- <vs-input class="w-full" v-model="data.min_volume"/> -->
                                        <vx-input-group>
                                            <template slot="append">
                                                <div class="append-text bg-primary">
                                                    <span>M3</span>
                                                </div>
                                            </template>

                                            <vs-input class="w-full" v-model="data.min_volume" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Weight Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.weight_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Min Weight</div>
                                    <div class="vx-col w-2/3">
                                        <!-- <vs-input class="w-full" v-model="data.min_weight"/> -->
                                        <vx-input-group>
                                            <template slot="append">
                                                <div class="append-text bg-primary">
                                                    <span>KG</span>
                                                </div>
                                            </template>

                                            <vs-input class="w-full" v-model="data.min_weight" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Max Weight</div>
                                    <div class="vx-col w-2/3">
                                        <!-- <vs-input class="w-full" v-model="data.max_weight"/> -->
                                        <vx-input-group>
                                            <template slot="append">
                                                <div class="append-text bg-primary">
                                                    <span>KG</span>
                                                </div>
                                            </template>

                                            <vs-input class="w-full" v-model="data.max_weight" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">Excess Weight Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.excess_weight_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">Quantity Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.quantity_rate" />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/3 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Multi Drop Rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.multi_drop_rate" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Applied After</div>
                                    <div class="vx-col w-2/3">
                                        <!-- <vs-input class="w-full" v-model="data.applied_after"/> -->
                                        <vx-input-group>
                                            <template slot="append">
                                                <div class="append-text bg-primary">
                                                    <span>Drops</span>
                                                </div>
                                            </template>

                                            <vs-input class="w-full" v-model="data.applied_after" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Load / Unload rate</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.load_unload_rate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.notes" label="Notes" height="200" />
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {
                // id: '',
                client_id: null,
                origin_id: null,
                destination_id: null,
                status: "",
                vehicle_type_id: null,
                contract_type_id: null,
                // service_type_id:null,

                // trip rate
                currency_id: null,
                fixed_rate: 0,
                quota_trip: 0,
                period_id: null,
                excess_trip_rate: 0,
                trip_rate: 0,

                //variable
                volume_rate: 0,
                min_volume: 0,
                weight_rate: 0,
                min_weight: 0,
                max_weight: 0,
                excess_weight_rate: 0,
                quantity_rate: 0,
                multi_drop_rate: 0,
                applied_after: 0,
                load_unload_rate: 0,

                // notes
                notes: "",
                is_active: true
            },
            clientTypeOptions: [],
            areaOptions: [],
            clientOption: [],
            vehicleTypeOption: [],
            contractTypeOption: [],
            serviceTypeOption: [],
            currencyOption: [],
            periodRateOption: [],
            maxRetry: 10
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        fetchData(api) {
            return this.$http.get(api);
        },
        searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/get_areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
        searchClient(search, loading) {
            if (search.length > 2) {
                loading(true);
                const data = {
                    name: search
                };
                this.$http
                    .post("master/clients/filter/search", data)
                    .then(res => {
                        this.clientOption = res.data;
                        loading(false);
                    })
                    .catch(() => {
                        this.searchClient(search, loading);
                    });
            }
        },
        searchVehicleType(search, loading) {
            if (search.length > 2) {
                loading(true);
                const data = {
                    name: search
                };
                this.$http
                    .post("master/vehicletypes/filter/search", data)
                    .then(res => {
                        this.clientOption = res.data;
                        loading(false);
                    })
                    .catch(() => {
                        this.searchVehicleType(search, loading);
                    });
            }
        },
        searchContractType(search, loading) {
            if (search.length > 2) {
                loading(true);
                const data = {
                    name: search
                };
                this.$http
                    .post("master/vehicletypes/filter/search", data)
                    .then(res => {
                        this.clientOption = res.data;
                        loading(false);
                    })
                    .catch(() => {
                        this.searchContractType(search, loading);
                    });
            }
        },
        searchServiceType(search, loading) {
            // if(search.length > 2){
            //     loading(true)
            //     const data = {
            //         name: search
            //     }
            //     this.$http.post('master/serve/filter/search', data)
            //     .then(res => {
            //         this.clientOption = res.data
            //         loading(false)
            //     })
            //     .catch(() => {
            //         this.searchServiceType(search, loading)
            //     })
            // }
        },
        submitForm() {
            this.isLoading = true;
            let data = {
                ...this.data,
                is_active: this.data.is_active == true ? 1 : 0
            };
            this.$http
                .post("master/clientrates/store", data)
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Saved Successfully",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Client Rate added"
                    });
                    this.$router.push({ name: "master-client-rate" });
                })
                .catch(error => {
                    this.isLoading = false;
                    for (const [index, err] of error.response.data.entries()) {
                        this.$vs.notify({
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: "" + err
                        });
                    }
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        back() {
            if (
                this.data.name != "" ||
                this.data.client_code != "" ||
                this.data.address_1 != "" ||
                this.data.address_2 != "" ||
                this.data.area_id != "" ||
                this.data.city != "" ||
                this.data.post_code != "" ||
                this.data.clienttype_id != ""
            ) {
                this.$vs.dialog({
                    color: "warning",
                    title: "Leave Page",
                    text: "Changes you made may not be saved?",
                    acceptText: "Leave Page",
                    accept: () => this.$router.go(-1)
                });
            } else {
                this.$router.go(-1);
            }
        },
        fetchAllData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.$http
                .all([
                    this.$http.post("master/get_areas"),
                    this.$http.post("master/clienttypes"),
                    this.$http.post("master/clients"),
                    this.$http.post("master/vehicletypes"),
                    this.$http.post("master/contracttypes"),
                    this.$http.post("master/currency"),
                    this.$http.post("master/periodrates"),
                    this.$http.post("master/servicetypes")
                ])
                .then(
                    this.$http.spread(
                        (
                            areas,
                            clienttypes,
                            clients,
                            vehicletypes,
                            contracttypes,
                            currency,
                            periodrates,
                            servicetypes
                        ) => {
                            this.clientOption = clients.data.data;
                            this.areaOptions = areas.data.data;
                            this.clientTypeOptions = clienttypes.data.data;
                            this.vehicleTypeOption = vehicletypes.data.data;
                            this.contractTypeOption = contracttypes.data.data;
                            this.currencyOption = currency.data;
                            this.periodRateOption = periodrates.data;
                            this.serviceTypeOption = servicetypes.data.data;

                            setTimeout(() => {
                                this.isLoading = false;
                            }, 500);
                        }
                    )
                )
                .catch(() => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.fetchAllData();
                                this.maxRetry = 10;
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchAllData();
                });
        }
    },
    mounted() {
        this.fetchAllData();
    }
};
</script>